import { render, staticRenderFns } from "./zbdy.vue?vue&type=template&id=210fcd08&scoped=true&"
import script from "./zbdy.vue?vue&type=script&lang=js&"
export * from "./zbdy.vue?vue&type=script&lang=js&"
import style0 from "./zbdy.vue?vue&type=style&index=0&id=210fcd08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fcd08",
  null
  
)

export default component.exports